package io.github.kingsword09.symbolcraft.symbols.icons.`simple-icons`.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.`simple-icons`.Icons

public val Icons.MetaSimpleIcons: ImageVector
    get() {
        if (_metaSimpleIcons != null) {
            return _metaSimpleIcons!!
        }
        _metaSimpleIcons = Builder(name = "MetaSimpleIcons", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 24.0f, viewportHeight = 24.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(6.92f, 4.03f)
                curveToRelative(-1.97f, 0.0f, -3.68f, 1.28f, -4.87f, 3.11f)
                curveTo(0.70f, 9.21f, 0.0f, 11.88f, 0.0f, 14.45f)
                curveToRelative(0.0f, 0.71f, 0.07f, 1.37f, 0.21f, 1.97f)
                arcToRelative(6.62f, 6.62f, 0.0f, false, false, 0.27f, 0.86f)
                arcToRelative(5.30f, 5.30f, 0.0f, false, false, 0.37f, 0.76f)
                curveToRelative(0.70f, 1.16f, 1.82f, 1.93f, 3.59f, 1.93f)
                curveToRelative(1.50f, 0.0f, 2.63f, -0.67f, 3.97f, -2.44f)
                curveToRelative(0.76f, -1.01f, 1.14f, -1.63f, 2.66f, -4.32f)
                lineToRelative(0.76f, -1.34f)
                lineToRelative(0.19f, -0.33f)
                curveToRelative(0.06f, 0.1f, 0.12f, 0.20f, 0.18f, 0.3f)
                lineToRelative(2.15f, 3.60f)
                curveToRelative(0.72f, 1.21f, 1.67f, 2.56f, 2.47f, 3.31f)
                curveToRelative(1.05f, 0.99f, 1.99f, 1.22f, 3.06f, 1.22f)
                curveToRelative(1.08f, 0.0f, 1.88f, -0.36f, 2.46f, -0.84f)
                arcToRelative(3.74f, 3.74f, 0.0f, false, false, 0.81f, -0.97f)
                curveToRelative(0.54f, -0.94f, 0.86f, -2.13f, 0.86f, -3.75f)
                curveToRelative(0.0f, -2.72f, -0.68f, -5.36f, -2.08f, -7.45f)
                curveToRelative(-1.28f, -1.91f, -2.96f, -2.93f, -4.72f, -2.93f)
                curveToRelative(-1.05f, 0.0f, -2.09f, 0.47f, -3.05f, 1.31f)
                curveToRelative(-0.65f, 0.57f, -1.26f, 1.29f, -1.82f, 2.05f)
                curveToRelative(-0.69f, -0.88f, -1.34f, -1.55f, -1.96f, -2.06f)
                curveToRelative(-1.18f, -0.97f, -2.32f, -1.30f, -3.45f, -1.30f)
                close()
                moveTo(17.08f, 6.08f)
                curveToRelative(1.15f, 0.0f, 2.19f, 0.76f, 2.99f, 2.00f)
                curveToRelative(1.13f, 1.75f, 1.65f, 4.20f, 1.65f, 6.4f)
                curveToRelative(0.0f, 1.55f, -0.37f, 2.9f, -1.84f, 2.9f)
                curveToRelative(-0.58f, 0.0f, -1.03f, -0.23f, -1.66f, -1.00f)
                curveToRelative(-0.50f, -0.60f, -1.34f, -1.88f, -2.83f, -4.36f)
                lineToRelative(-0.62f, -1.03f)
                arcToRelative(44.91f, 44.91f, 0.0f, false, false, -1.26f, -1.98f)
                curveToRelative(0.07f, -0.11f, 0.14f, -0.22f, 0.21f, -0.33f)
                curveToRelative(1.12f, -1.67f, 2.12f, -2.60f, 3.36f, -2.60f)
                close()
                moveTo(6.87f, 6.64f)
                curveToRelative(1.27f, 0.0f, 2.06f, 0.79f, 2.68f, 1.45f)
                curveToRelative(0.31f, 0.33f, 0.74f, 0.87f, 1.23f, 1.58f)
                lineToRelative(-1.02f, 1.57f)
                curveToRelative(-0.76f, 1.16f, -1.88f, 3.02f, -2.84f, 4.34f)
                curveToRelative(-1.19f, 1.65f, -1.81f, 1.82f, -2.49f, 1.82f)
                curveToRelative(-0.52f, 0.0f, -1.04f, -0.24f, -1.38f, -0.79f)
                curveToRelative(-0.26f, -0.43f, -0.46f, -1.13f, -0.46f, -2.05f)
                curveToRelative(0.0f, -2.22f, 0.63f, -4.54f, 1.66f, -6.09f)
                curveToRelative(0.45f, -0.69f, 0.96f, -1.23f, 1.53f, -1.53f)
                arcToRelative(2.26f, 2.26f, 0.0f, false, true, 1.09f, -0.29f)
                close()
            }
        }
        .build()
        return _metaSimpleIcons!!
    }

private var _metaSimpleIcons: ImageVector? = null
